/**
 * User-facing copy for AI token usage on successful AI campaign requests.
 */

function formatAiTokenUsageToastSuffix(tokenUsage) {
  const totalTokens = Number(tokenUsage?.totalTokens || tokenUsage?.total_tokens || 0);
  const costInr = Number(tokenUsage?.estimatedCostInr ?? tokenUsage?.estimated_cost_inr);
  const hasCost = Number.isFinite(costInr) && costInr > 0;
  if ((!Number.isFinite(totalTokens) || totalTokens <= 0) && !hasCost) {
    return "";
  }

  const inputTokens = Number(tokenUsage?.inputTokens || tokenUsage?.input_tokens || 0);
  const outputTokens = Number(tokenUsage?.outputTokens || tokenUsage?.output_tokens || 0);
  let message = "";
  if (Number.isFinite(totalTokens) && totalTokens > 0) {
    message += ` ${totalTokens.toLocaleString()} AI tokens used`;
    if (inputTokens > 0 || outputTokens > 0) {
      message += ` (${inputTokens.toLocaleString()} in / ${outputTokens.toLocaleString()} out)`;
    }
    if (tokenUsage?.estimated) {
      message += " (estimated)";
    }
  }
  if (hasCost) {
    message += `${message ? " · " : " "}₹${costInr.toFixed(2)}`;
  }
  return `${message}.`;
}

export function buildAiCampaignSuccessMessage(baseMessage, response) {
  const tokenUsage = response?.tokenUsage || response?.token_usage || null;
  const suffix = formatAiTokenUsageToastSuffix(tokenUsage);
  return suffix ? `${String(baseMessage || "").trim()}${suffix}` : String(baseMessage || "").trim();
}

export { formatAiTokenUsageToastSuffix };
